'use client'

import { useCallback, useEffect, useState } from 'react'

export const useMobile = () => {
    const [isMobile, setIsMobile] = useState<boolean>()

    const onResize = useCallback(() => {
        if (typeof window === 'undefined') return

        setIsMobile(window.innerWidth <= 768)
    }, [])

    useEffect(() => {
        onResize()
        // listen to window resize
        window.addEventListener('resize', onResize)

        // remove event listener on cleanup
        return () => window.removeEventListener('resize', onResize)
    }, [onResize])

    return isMobile
}
